export const list = {
    data: [{
        key: 'preqin',
        name: 'Preqin',
    }, {
        key: 'qreports',
        name: 'Qualitas Reports',
    }, {
        key: 'excellow',
        name: 'Excel Low Priority',
    }, {
        key: 'excelhigh',
        name: 'Excel High Priority',
    }, {
        key: 'computed',
        name: 'Computed',
    }, {
        key: 'manual',
        name: 'Manual',
    }],
}

export default {
    list,
}
